<template>
    <v-container fluid grid-list-md class="horizontal-padding-content">
        <v-row>
            <v-col cols="12">
                <v-card class="rounded-card" height="100%">
                    <v-card-title class="primary--text pt-1 pb-0">
                        <v-row :class="{ 'pb-0 mb-0': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }">
                            <v-col order-lg="2" cols="12" lg="6" class="text-uppercase primary--text text-center font-weight-black">
                                Facturas Liquidadas
                            </v-col>
                            <v-col order-lg="1" cols="12" lg="3" md="6">
                                <v-menu
                                  :close-on-content-click="true"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      class="capitalize-input"
                                      outlined
                                      dense
                                      label="Mes de Liquidación"
                                      append-icon="mdi-menu-down"
                                      v-on="on"
                                      v-model="dateFormatted"
                                    />
                                  </template>
                                  <v-date-picker
                                    type="month"
                                    v-model="month"
                                    locale="es"
                                    @change="loadRecords()"
                                    />
                              </v-menu>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.lgAndUp" order-lg="3" cols="0" lg="3" class="text-right">
                                <!-- <v-chip
                                  v-model="currencyFilterUSD"
                                  class="mr-2"
                                  :class="{'active-chip': currencyFilterUSD === true,  'inactive-chip': currencyFilterUSD === false }"
                                  @click="toggleFilter('currencyFilterUSD')">USD</v-chip>
                                <v-chip
                                  v-model="currencyFilterMXN"
                                  class="mr-2"
                                  :class="{'active-chip': currencyFilterMXN === true,  'inactive-chip': currencyFilterMXN === false }"
                                  @click="toggleFilter('currencyFilterMXN')">MXN</v-chip> -->
                            </v-col>
                            <v-col
                              order-lg="2"
                              cols="12"
                              lg="3"
                              md="6"
                              class="text-center"
                              :class="{ 'py-0 my-0': $vuetify.breakpoint.mdAndDown }"
                            >
                              <ExportTable
                                :fileName="fileName"
                                :dataToExport="exportData"
                                :mapFunction="mapFunction"
                                :reloadData="reloadData"
                                :dateFilter="'paymentDate'"
                                :filterName="'Fecha de pago'"
                                :filterValue="{ init: searchRecord.fechaPagoInicial, fin: searchRecord.fechaPagoFinal, format: 'YYYY-MM-DD' }"
                                :headers="excelHeaders"
                              />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text
                      class="primary--text pt-1 pb-0"
                      :class="{ 'pt-0 mt-0': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }"
                    >
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                  :fixed-header="true"
                                  :height="650"
                                  :headers="headers"
                                  :items="records"
                                  :loading="loading"
                                  loading-text="Cargando datos"
                                  no-data-text="No hay datos para mostrar"
                                  class="elevation-2"
                                  :class="{ 'mt-0 pt-0': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs }"
                                  :footer-props="{
                                    'items-per-page-all-text': 'Todos',
                                    'items-per-page-options': [-1],
                                    'disable-pagination': true
                                  }">
                                    <template v-slot:[`item.producto`]="{ item }">
                                        <span v-if="item.producto === 'BI'">BLÚ INDEX</span>
                                        <span v-if="item.producto === 'FB'">FACTORAJE AMERICAN</span>
                                    </template>
                                    <template v-slot:[`item.emittedOn`]="{ item }">
                                        {{ item.emittedOn | dateShort }}
                                    </template>
                                     <template v-slot:[`item.dueDate`]="{ item }">
                                        {{ item.dueDate | dateShort }}
                                    </template>
                                     <template v-slot:[`item.paymentDate`]="{ item }">
                                        {{ item.paymentDate | dateShort }}
                                    </template>
                                     <template v-slot:[`item.depositDate`]="{ item }">
                                        {{ item.credit ? item.credit.fechaInicio : '' | dateShort }}
                                    </template>
                                    <template v-slot:[`item.total`]="{ item }">
                                        {{ item.total | currency }}
                                    </template>
                                    <template v-slot:[`item.anticipo`]="{ item }">
                                        {{ item.anticipo | currency }}
                                    </template>
                                    <template v-slot:[`item.comision`]="{ item }">
                                        {{ item.comision | currency }}
                                    </template>
                                    <template v-slot:[`item.recargos`]="{ item }">
                                        {{ item.recargos | currency }}
                                    </template>
                                    <template v-slot:[`item.initialDeposit`]="{ item }">
                                        {{ item.initialDeposit | currency }}
                                    </template>
                                    <template v-slot:[`item.finalDeposit`]="{ item }">
                                        {{ item.finalDeposit | currency }}
                                    </template>
                                    <template v-slot:[`item.receiverName`]="{ item }">
                                        <span class="text-uppercase">{{ item.receiverName }}</span>
                                    </template>
                                    <template v-slot:[`item.source`]="{ item }">
                                      <div v-if="item.producto === 'BI'">
                                        <span class="text-uppercase payment">
                                          {{item.source}} <br v-if="item.bank">
                                          <strong v-if="item.bank">Banco: </strong>{{item.bank}}
                                        </span>
                                      </div>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import FactoringDocumentService from '@/services/FactoringDocumentService'
import ExportTable from '@/components/ExportTable'
import moment from 'moment'
import Mixins from '@/mixins/index.js'

export default {
  name: 'InvoicesHistory',
  mixins: [Mixins],
  components: {
    ExportTable
  },
  data () {
    return {
      loading: false,
      searchRecord: {
        showCredit: true,
        rfc: '',
        fechaPagoInicial: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
        fechaPagoFinal: moment(new Date()).endOf('month').format('YYYY-MM-DD')
      },

      records: [],
      exportData: [],
      month: new Date().toISOString().substr(0, 10),
      dateFormatted: moment(new Date()).locale('es').format('MMMM YYYY'),
      fileName: 'Facturas liquidadas',
      headers: [
        { text: 'Pagador', value: 'receiverName', align: 'left', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Folio', value: 'folio', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'F. Emisión', value: 'emittedOn', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Importe', value: 'total', align: 'right', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Moneda', value: 'currency', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Anticipo', value: 'initialDeposit', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'F. Depósito', value: 'depositDate', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'F. Vencimiento', value: 'dueDate', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'F. Pago', value: 'paymentDate', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Interés', value: 'comision', align: 'right', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Recargos', value: 'recargos', align: 'right', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Devolución', value: 'finalDeposit', align: 'right', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Pago automático', value: 'source', align: 'center', class: 'primary--text font-weight-black text-uppercase' }
      ],
      excelHeaders: {
        receiverName: 'Pagador',
        folio: 'Folio',
        emittedOn: 'F. Emisión',
        total: 'Importe',
        currency: 'Moneda',
        initialDeposit: 'Anticipo',
        depositDate: 'F. Depósito',
        dueDate: 'F. Vencimiento',
        paymentDate: 'F. Pago',
        comision: 'Interés',
        recharge: 'Recargos',
        finalDeposit: 'Devolución',
        bank: 'Banco',
        source: 'CLABE'
      }
    }
  },

  beforeCreate () {
    if (!this.$store.getters.isLoggedIn) {
      const routeData = this.$router.resolve({ name: 'login' })
      window.open(routeData.href, '_self')
    }
  },

  mounted () {
    if (this.$store.getters.isLoggedIn) {
      this.loadRecords()
    }
  },

  watch: {
    month (val) {
      this.dateFormatted = moment(this.month).locale('es').format('MMMM YYYY')
      this.searchRecord.fechaPagoInicial = moment(this.month).startOf('month').format('YYYY-MM-DD')
      this.searchRecord.fechaPagoFinal = moment(this.month).endOf('month').format('YYYY-MM-DD')
    }
  },

  methods: {
    mapFunction (item) {
      return Object.assign({
        receiverName: item.receiverName,
        folio: item.folio,
        emittedOn: item.emittedOn,
        total: item.total,
        currency: item.currency,
        initialDeposit: item.initialDeposit,
        depositDate: item.credit?.fechaInicio ?? null,
        dueDate: item.dueDate,
        paymentDate: item.paymentDate,
        comision: item.comision,
        recharge: item.recargos,
        finalDeposit: item.finalDeposit,
        bank: item.bank,
        source: item.source
      })
    },

    async reloadData (init, fin, format) {
      const loader = this.$loading.show()
      const searchRecord = Object.assign({}, this.searchRecord)
      searchRecord.fechaPagoInicial = moment(init, format).locale('es').format('YYYY-MM-DD')
      searchRecord.fechaPagoFinal = moment(fin, format).locale('es').format('YYYY-MM-DD')
      searchRecord.showCredit = true
      try {
        const { data } = await FactoringDocumentService.getDocuments(searchRecord)
        this.exportData = await this.setRecords(data)
        loader.hide()
      } catch (error) {
        console.error(error)
        loader.hide()
        throw new Error(error.message)
      }
    },

    async loadRecords () {
      const loader = this.$loading.show()
      this.loading = true
      this.searchRecord.clientId = this.$store.getters.user.clientId
      try {
        const { data } = await FactoringDocumentService.getDocuments(this.searchRecord)
        this.records = await this.setRecords(data)
        loader.hide()
        this.loading = false
      } catch (error) {
        loader.hide()
        console.error(error)
      }
    },

    async setRecords (records) {
      try {
        const uuids = records.map(item => item.uuid)
        const { data } = await FactoringDocumentService.getDocumentsPaymentInformation({ uuids })
        data.map(inv => {
          const invoice = records.find(item => item.uuid.toUpperCase() === inv.uuid.toUpperCase())
          if (invoice && inv.StpPaymentOrder) {
            invoice.source = inv.StpPaymentOrder.source || 'Desconocido'
            invoice.bank = 'Desconocido'
            if (inv.StpPaymentOrder.Bank) {
              invoice.bank = inv.StpPaymentOrder.Bank.name || 'Desconocido'
            }
          }
        })
      } catch (error) {
        console.error(error)
      }
      return records.map(item => item)
    }
  }
}
</script>

<style>
    .capitalize-input input {
        text-transform: uppercase !important;
        color: #0420BF!important;
        font-weight: 900 !important;
        font-size: 20px !important;
    }
    .payment {
        text-transform: capitalize;
        font-weight: bold;
        font-size: smaller;
    }
</style>
